import StarRating from 'components/StarRating';
import React from 'react';

const CSS = require('./ExperienceItemDetailsBottom.module.scss');

interface ExperienceItemDetailsBottomProps {
  rating: number;
  nrOfReviews: number;
  price: string;
  duration: string;
}

function ExperienceItemDetailsBottom({
  rating = 5,
  nrOfReviews = 0,
  price,
  duration,
}: ExperienceItemDetailsBottomProps) {
  return (
    <div className={CSS.ExperienceItemDetailsBottom}>
      <StarRating rating={rating} usePartials />
      {nrOfReviews > 0 && (
        <span className={CSS.Label}>
          {nrOfReviews} review{nrOfReviews > 1 && 's'}
        </span>
      )}
      <span>&nbsp;&#8226;&nbsp;</span>
      <span className={CSS.Label}>{price} pp</span>
      <span>&nbsp;&#8226;&nbsp;</span>
      <span className={CSS.Label}>{duration}</span>
    </div>
  );
}

export default ExperienceItemDetailsBottom;
